import { Wallet, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

interface CashRegisterClosedOverlayProps {
  onExit: () => void;
}

export function CashRegisterClosedOverlay({ onExit }: CashRegisterClosedOverlayProps) {
  const navigate = useNavigate();

  const handleGoToCaixa = () => {
    if (document.fullscreenElement) {
      document.exitFullscreen().catch(console.error);
    }
    navigate("/dashboard/caixa");
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-background/95 backdrop-blur-sm">
      <div className="max-w-md w-full mx-4 text-center space-y-6">
        <div className="flex justify-center">
          <div className="h-20 w-20 rounded-full bg-amber-100 dark:bg-amber-900/30 flex items-center justify-center">
            <Wallet className="h-10 w-10 text-amber-600" />
          </div>
        </div>

        <div className="space-y-2">
          <h1 className="text-2xl font-bold text-foreground">
            Caixa Fechado
          </h1>
          <p className="text-muted-foreground">
            Não é possível realizar vendas com o caixa fechado.
            Abra o caixa para iniciar um novo turno de vendas.
          </p>
        </div>

        <div className="flex flex-col gap-3">
          <Button
            size="lg"
            className="gap-2 w-full"
            onClick={handleGoToCaixa}
          >
            Ir para Caixa
            <ArrowRight className="h-4 w-4" />
          </Button>
          <Button
            variant="outline"
            size="lg"
            className="w-full"
            onClick={onExit}
          >
            Voltar ao Dashboard
          </Button>
        </div>
      </div>
    </div>
  );
}
